import { api } from '@/lib/api';

/**
 * Cafe/restaurant menu images (client change, 9 Oct 2026): the menu is a set of photos of
 * the menu card, not typed items. Mirrors backend/src/modules/menu-image.
 */
export interface MenuImage {
  id: string;
  display_order: number;
  original_filename: string;
  /** Authenticated path; append ?variant=thumb|medium|full. */
  file_path: string;
  uploaded_at: string;
}

/** Same cap as the backend. */
export const MAX_MENU_IMAGES = 10;

const BASE = '/vendor/menu-images';

export async function fetch_menu_images(): Promise<MenuImage[]> {
  const res = await api.get<MenuImage[]>(BASE);
  return res.data;
}

export async function upload_menu_image(file: File): Promise<MenuImage[]> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<MenuImage[]>(BASE, form, { headers: { 'Content-Type': 'multipart/form-data' } });
  return res.data;
}

export async function reorder_menu_images(ids: string[]): Promise<MenuImage[]> {
  const res = await api.put<MenuImage[]>(`${BASE}/order`, { ids });
  return res.data;
}

export async function delete_menu_image(id: string): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}
